<template>
	<div style="background-color: #eee">
		
		<div class="section_title mb-6">
			<div>Click Day Attivo</div>
			<div></div>
		</div>
		<click-day-box-component
			:key="bandoAttivoKey"
			:id-cliccatore="idCliccatore"
		></click-day-box-component>
		
		<div class="section_title mb-6">
			<div class="titolo_clickday_passato"
			>
				Altri Click Day
			</div>
			<div class="linea_clickday_passato"></div>
		</div>
		<click-day-box-component
			v-for="bando in bandiNonAttivi"
			:key="bando.id"
			:bando-id="bando.id"
			:idCliccatore="idCliccatore"
		></click-day-box-component>
		
	</div>
</template>

<script>
export default {
	props: {
		idCliccatore: {
			default: null
		}
	},
	data() {
		return {
			isLoadingBandiNonAttivi: false,
			bandiNonAttivi: [
				// {
				//
				// },
				// ...
			],
			
			bandoAttivoKey: 0
		}
	},
	
	created() {
		this.getBandiNonAttivi();
	},
	
	methods: {
		getBandiNonAttivi() {
			this.isLoadingBandiNonAttivi = true;
			return axios.get('/clickdayit/bandi-non-attivi')
				.then(response => {
					this.bandiNonAttivi = response.data;
				})
				.finally(() => {
					this.isLoadingBandiNonAttivi = false;
				})
		}
	}
}
</script>

<style lang="scss" scoped>
.section_title {
	background-color: #eee;
	//padding-top: 30px;
	display: flex;
	div {
		width: 50%;
		&.titolo_clickday_passato {
			background-color: #acb5c2;
		}
	}
	:nth-child(1) {
		font-size: 20px;
		font-weight: 700;
		text-align:center;
		background-color: #6D94CD;
		padding: 10px 15px;
		color:white
	}
	:nth-child(2) {
		border-bottom: 5px solid #6D94CD;
		&.linea_clickday_passato {
			border-bottom: 5px solid #acb5c2;
		}
	}
}
//.gameday_passato {
//	background-color: #acb5c2;
//}
</style>